module.exports = __webpack_public_path__ + "img/934.1450b267.gif";